import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy, Suspense } from "react";
import PaymentOneClick from "./PaymentOneClick.js";
// Lazy load Stripe component to prevent loadStripe() from running at module level
// This prevents EIP-6963 wallet detection events when Stripe is not used
const PaymentStripeWeb2 = lazy(() => import("./PaymentStripeWeb2"));
function StripeLoadingFallback() {
    return (_jsx("div", { className: "relative my-8 flex w-full flex-1 flex-col items-center justify-center", children: _jsxs("div", { className: "bg-as-on-surface-1 flex w-full flex-col items-center justify-center gap-4 rounded-2xl p-8", children: [_jsx("div", { className: "bg-as-brand/20 flex h-16 w-16 items-center justify-center rounded-full", children: _jsx("div", { className: "text-as-brand h-8 w-8 animate-spin rounded-full border-2 border-current border-t-transparent" }) }), _jsxs("div", { className: "text-as-primary/70 text-center", children: [_jsx("div", { className: "text-lg font-medium", children: "Loading payment" }), _jsx("div", { className: "text-as-primary/50 mt-2 text-sm", children: "Initializing secure payment form..." })] })] }) }));
}
export default function PaymentVendorUI({ order, dstTokenSymbol }) {
    const vendor = order.onrampMetadata?.vendor;
    // Handle one-click payment flows (Coinbase, Stripe redirect)
    if (order.oneClickBuyUrl) {
        return _jsx(PaymentOneClick, { order: order, dstTokenSymbol: dstTokenSymbol });
    }
    // Handle Stripe Web2 payment flow
    if (vendor === "stripe-web2" && order.stripePaymentIntentId) {
        return (_jsx(Suspense, { fallback: _jsx(StripeLoadingFallback, {}), children: _jsx(PaymentStripeWeb2, { order: order, stripePaymentIntentId: order.stripePaymentIntentId }) }));
    }
    // Return null for unsupported vendors
    return null;
}
